import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import cogoToast from "cogo-toast";
import { useUpdateSafeLockStatusMutation } from "../../../../../redux/apiSlice";
import { errorMessage } from "../../../../util/Helpers";
import TextInput from "../../../Common/components/text-input";

export const UpdateEarnStatusModal = ({ show, onHide }) => {
    const [
        updateSafeLockStatus,
        { isLoading }
    ] = useUpdateSafeLockStatusMutation();

    const validationSchema = Yup.object().shape({
        transactionRef: Yup.string().required("Transaction Reference is required"),
    });

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    Update Earn Transaction Status
                </Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={{ transactionRef: "" }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    updateSafeLockStatus({ transactionRef: values.transactionRef })
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Update Earn Transaction status created");
                            setSubmitting(false);
                            resetForm();
                            onHide();
                        })
                        .catch((error) => {
                            setSubmitting(false);
                            cogoToast.error(errorMessage(error));
                        });
                }}
            >
                {({
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <div className="form-group">
                                <TextInput
                                    name="transactionRef"
                                    label="Transaction Reference"
                                    placeholder="Enter Transaction Reference"
                                    type="text"
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={onHide}
                                disabled={isLoading || isSubmitting}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={isLoading || isSubmitting}
                            >
                                {isLoading || isSubmitting ? "Updating..." : "Update Status"}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};
